export const useStyles = () => {
  return {
    root: {
      position: 'relative',

      fontSize: '16px',
      textAlign: 'left',
      color: 'black',
      paddingTop: 2,
      paddingRight: 3,
      paddingBottom: 2,

      '& .textLayer .markedContent:first-of-child': {
        display: 'none',
      },
    },
    page: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
      fontSize: 16,
      letterSpacing: '0.01em',
      fontWeight: 300,

      '& > div:first-of-type': {
        display: 'none',
      },

      '& span': {
        fontWeight: 600,
        letterSpacing: '0.01em',

        '@media (max-width: 991px)': {
          fontSize: 16,
        },
      },

      '@media (max-width: 991px)': {
        fontWeight: 300,
      },
    },
    row: {
      marginTop: 2,
      marginBottom: 0.5,
      fontSize: 24,

      '@media (max-width: 991px)': {
        fontSize: 18,
      },
    },
  };
};
